<app-data-table [configuration]="dataTableConfiguration"></app-data-table>

<ng-template #detailsRow let-row="row">
  @if (row?.details) {
    <div class="p-2 caption">
      {{ 'followUps.timeline.changedTo' | translate }}:
      {{ row.details | displayName: users }}
    </div>
  }
</ng-template>
